<template>
  <div class="outer-wrapper">
      <div v-if="currentShow==='list'">
          <div class="title-wrapper">
            <p>项目</p>
            <van-icon name="add-o" class="add-b" @click="()=>sw.add=true"/>
            </div>
            <van-search v-model="optionData.keyword" placeholder="请输入搜索关键词" />
            <van-list
            v-model="tableList.loading"
            :finished="tableList.finished"
            finished-text="没有更多了"
            :error.sync="tableList.error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
            >
            <van-swipe-cell v-for="(item, index) in tableList.tivdata"
                :key="index + 'su'">
            <van-cell
                
                :title="item.name"
                :value="item.contract_date"
                is-link
                @click="viewItem(item)"
            >
                <template #label>
                <div>
                    <p>{{ item.line_name }}</p>
                </div>
                </template>
            </van-cell>
            <template #right>
                <van-button square type="danger" text="删除" style="height: 100%;" @click="contractDelConfirmBox(item)"/>
            </template>
            </van-swipe-cell>
            </van-list>
      </div>
      <div v-else-if="currentShow==='item'">
          <van-nav-bar
            title="项目详情"
            left-text="返回"
            left-arrow
            @click-left="goBack('list')"
            fixed
            >
            </van-nav-bar>
            <van-swipe-cell>
            <van-cell center title="编号" :value="currentItem.display_no"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('display_no','编号')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="项目名称" :value="currentItem.name"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('name','项目名称')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="项目简称" :value="currentItem.abbr"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('abbr','项目简称')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="工程名称" :value="currentItem.line_name"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('line_name','工程名称')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="施工单位" :value="currentItem.constructor"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('constructor','施工单位')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="联系人" :value="currentItem.contactor"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('contactor','联系人')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="电话" :value="currentItem.phone"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('phone','电话')"/>
            </template>
            </van-swipe-cell>
             <van-swipe-cell>
            <van-cell center title="项目类型" :value="currentItem.category"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('category','项目类型')"/>
            </template>
            </van-swipe-cell>
             <van-swipe-cell>
            <van-cell center title="签定日期" :value="currentItem.contract_date"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('contract_date','签定日期','date')"/>
            </template>
            </van-swipe-cell>
             <van-swipe-cell>
            <van-cell center title="合同总价" :value="currentItem.price"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('price','合同总价')"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell>
            <van-cell center title="备注" :value="currentItem.remark"  />
            <template #right>
                <van-button square type="warning" text="修改" style="height: 100%;" @click="itemAlter('remark','备注')"/>
            </template>
            </van-swipe-cell>
            <van-cell center title="更多联系人" is-link @click="moreContactorView"/>
            <van-cell center title="生产单位" is-link  @click="manufacturerView"/>
           
      </div>
      <div v-else-if="currentShow==='contactor'">
        <van-nav-bar
            title="更多联系人"
            left-text="返回"
            right-text="添加"
            left-arrow
            @click-left="goBack('item')"
            @click-right="addContactor"
            fixed
            >
        </van-nav-bar>
        <van-swipe-cell v-for="(item,index) in currentItem.mcontactor" :key="index">
            <van-cell center :title="item.name" :value="item.phone"  />
            <template #right>
                <van-button square type="danger" text="删除" style="height: 100%;" @click="mcontactorDel(index)"/>
            </template>
            </van-swipe-cell>
      </div>
      <div v-else-if="currentShow==='manufacturer'">
        <van-nav-bar
            title="生产单位"
            left-text="返回"
            right-text="添加"
            left-arrow
            @click-left="goBack('item')"
            @click-right="addManufacturer"
            fixed
            >
            </van-nav-bar>
            <template v-for="(item,index) in currentItem.manufacturer">
            <van-swipe-cell  :key="index+'n'">
            <van-cell center :title="item.name"   />
            <template #right>
                <van-button square type="danger" text="删除" style="height: 100%;" @click="manufacturerDel(index)"/>
            </template>
            </van-swipe-cell>
            <van-swipe-cell  v-for="(c,si) in item.contactor" :key="si+'n'+index" v-show="c.name+c.phone!==''">
            <van-cell center :title="c.name" :value="c.phone"  />
            <template #right>
                <van-button square type="danger" text="删除" style="height: 100%;" @click="mcDel(index,si)"/>
            </template>
            </van-swipe-cell>
            </template>
      </div>
    
    <van-dialog v-model="sw.add" title="新建项目" show-cancel-button @confirm="handleSubmit">
        <div>
          <van-field v-model="contract.display_no" label="编号：" label-align="right"/>
            <van-field v-model="contract.name" label="项目名称：" label-align="right"/>
            <van-field v-model="contract.abbr" label="项目简称：" label-align="right"/>
            <van-field v-model="contract.line_name" label="工程名称：" label-align="right"/>
            <van-field v-model="contract.constructor_name" label="施工单位：" label-align="right"/>
            <van-field v-model="contract.contactor" label="联系人：" label-align="right"/>
            <van-field v-model="contract.phone" label="电话：" label-align="right"/>
            <van-field v-model="contract.category" label="项目类型：" label-align="right" />
            <p class="s-w">
                <span>签定日期：</span>
                <span><input type="date" v-model="contract.contract_date" /></span>
            </p>
            <van-field v-model="contract.price" label="合同总价：" label-align="right" />
            <van-field v-model="contract.remark" label="备注：" label-align="right"/>
        </div>
    </van-dialog>
   
    <van-dialog v-model="sw.alter" :title="'修改'+currentText" show-cancel-button @confirm="alterSubmit">
        <div class="i-wrapper-h">
            <input :type="currentType" v-model="currentValue" class="s-input" />
        </div>
    </van-dialog>

    <van-dialog v-model="sw.contactor" title="添加联系人" show-cancel-button @confirm="addContactorSubmit">
        <div>
          <van-field v-model="contactor.name" label="姓名：" label-align="right"/>
          <van-field v-model="contactor.phone" label="电话：" label-align="right"/>
        </div>
    </van-dialog>
    <van-dialog v-model="sw.manufacturer" title="添加生产单位" show-cancel-button @confirm="addManufacturerSubmit">
        <div>
          <van-field v-model="manufacturer.name" label="单位名称：" label-align="right"/>
          <template v-for="(c,index) in manufacturer.contactor">
            <van-cell center :title="'联系人'+(index+1)"   :key="index+'t'"/>
            <van-field v-model="c.name" label="姓名：" label-align="right" :key="index+'n'"/>
            <van-field v-model="c.phone" label="电话：" label-align="right" :key="index+'p'"/>
          </template>
        </div>
    </van-dialog>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");

function myTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

const OPTIONDATA = {
  category:[
    {text:'全部状态',value:''},
    {text:'厂家送检',value:'厂家送检'},
    {text:'现场送检',value:'现场送检'},
  ],
  order:[
    {text:'默认排序',value:''},
    {text:'要求日期',value:'demand'},
    {text:'委托日期',value:'create'},
  ],
  esc:[
    {text:'排序方向',value:'DESC'},
    {text:'倒序',value:'DESC'},
    {text:'顺序',value:'ESC'}
  ]
}

function optionDataFac() {
  return {
    name:'',
    abbr:'',
    line_name:'',
    category:OPTIONDATA.category[0].value,
    keyword:'',
    order:'',
    esc:OPTIONDATA.esc[0].value
  };
}


function contractFac() {
  return {
    name: "",
    display_no:"",
    line_name: "",
    contract_date: null,
    category: "",
    remark: "",
    price: 0,
    constructor_name: "",
    contactor: "",
    phone: "",
    abbr: "",
  };
}

function contactorFac() {
  return {
    name: "",
    phone:"",
  };
}

function manufacturerFac() {
  return {
    name: "",
    contactor:[
      {name:"",phone:""},
      {name:"",phone:""},
      {name:"",phone:""},
      {name:"",phone:""},
    ]
  };
}

export default {
  name: "wcManage",
  components: {},
  mixins: [],
  props: {
    ifLink: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableList: myTableFac(),
      optionData: optionDataFac(),
      currentShow:'list',
      sw:{
          add:false,
          alter:false,
          contactor:false,
          manufacturer:false,
      },
      contract: contractFac(),
      currentLabel:"",
      currentText:"",
      currentValue:"",
      currentType:'text',
      contactor:contactorFac(),
      manufacturer:manufacturerFac(),
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() {
      if(this.ifLink==='y'){
          this.sw.add = true;
      }
  },
  methods: {
    onSearch() {
      this.tableList = myTableFac();
      this.onLoad();
    },
   
    getStaticOptions() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "wcList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.staticOptions = response.data.res_record;
            this.optionData.category = this.staticOptions.category[0].value;
          } else {
            this.$toast.fail("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "网络错误！操作失败。");
        });
    },
    
    // getActiveOptions() {
    //   this.$axios
    //     .post(this.$url + "/ask_option_data", {
    //       userToken: userToken,
    //       ask_data: "wcList",
    //     })
    //     .then((response) => {
    //       if (response.data.stat === "ok") {
    //         this.wcList = response.data.res_record;
    //         this.intention.wc_id = this.wcList[0].id;
    //       } else {
    //         this.$toast.fail("未找到选项数据");
    //       }
    //     })
    //     .catch((error) => {
    //       this.$toast.fail(error + "网络错误！操作失败。");
    //     });
    // },
    onLoad() {
      this.tableList.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.tableList.Tpage,
          userToken: userToken,
          ask_data: "wcList",
          enid: this.enid,
          optionData: this.optionData,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            this.tableList.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.tableList.Tpage.currentSize
          ) {
            this.tableList.finished = true;
          }
          this.tableList.loading = false;
          this.tableList.Tpage.currentPage++;
        });
    },
    handleSubmit() {
          let form = new FormData();
          form.append("userToken", userToken);
          form.append("askData", "createContract");
          form.append("contract", JSON.stringify(this.contract));
          let config = {
            headers: { "Content-Type": "multipart/form-data" },
          };
          this.$axios
            .post(this.$url + "/intention", form, config)
            .then((response) => {
              if (response.data.stat === "ok") {
                  if(this.ifLink==='y'){
                      location.href = '/intention/rpManage';
                  }else{
                      this.onSearch();
                  }
              } else {
                this.$toast.fail(response.data.info);
              }
            })
            .catch((error) => {
              this.$toast.fail(error + "未知错误！");
            });
    },
    contractDelConfirmBox(value) {
      this.$dialog.confirm({
        title: "确认删除：",
        message: "项目：" + value.name,
      }).then(
          ()=>{
                this.recordDel(value.id, "contractDel");
          }
      ).catch(
          ()=>{}
      );
    },
    recordDel(id, label) {
      this.$axios
        .post(this.$url + "/intention", {
          pid: id,
          askData: label,
          userToken: userToken,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("删除成功！");
            this.onSearch();
          } else {
            this.$toast.fail(response.data.info);
          }
        });
    },
    itemAlter(label,text,t='text'){
        this.currentLabel = label;
        this.currentText = text;
        this.currentValue = this.currentItem[label];
        this.currentType = t;
        this.sw.alter  = true;
    },
    alterSubmit(){
        let form = new FormData();
          form.append("userToken", userToken);
          form.append("askData", "alterWc");
          form.append("rp_id", this.currentItem.id);
          form.append("label", this.currentLabel);
          form.append("value", this.currentValue);
          let config = {
            headers: { "Content-Type": "multipart/form-data" },
          };
          this.$axios
            .post(this.$url + "/intention", form, config)
            .then((response) => {
              if (response.data.stat === "ok") {
                  this.currentItem[this.currentLabel] = this.currentValue;
                  this.$toast.success("数据修改成功！");
                  this.sw.alter = false;
              } else {
                this.$toast.fail(response.data.info);
              }
            })
            .catch((error) => {
              this.$toast.fail(error + "未知错误！");
            });
    },
    viewItem(item){
      this.currentItem = item;
    this.currentShow = "item";
    },
    goBack(label) {
      this.currentShow = label;
    },
    
    moreContactorView(){
      this.currentShow = "contactor";
    },
    manufacturerView(){
      this.currentShow = "manufacturer";
    },
    addContactor(){
      this.contactor = contactorFac();
      this.sw.contactor = true;
    },
    addContactorSubmit(){
      this.currentItem.mcontactor.push(JSON.parse(JSON.stringify(this.contactor)));
      this.updateJson('Mcontactor');
    },
    addManufacturer(){
      this.manufacturer = manufacturerFac();
      this.sw.manufacturer = true;
    },
    addManufacturerSubmit(){
      this.currentItem.manufacturer.push(JSON.parse(JSON.stringify(this.manufacturer)));
      this.updateJson('Manufacturer');
    },
    mcontactorDel(index){
      this.currentItem.mcontactor.splice(index,1);
      this.updateJson('Mcontactor');
    },
    manufacturerDel(index){
      this.currentItem.manufacturer.splice(index,1);
      this.updateJson('Manufacturer');
    },
    mcDel(index,si){
      this.currentItem.manufacturer[index].contactor.splice(si,1);
      this.updateJson('Manufacturer');
    },
    updateJson(key){
       let form = new FormData();
      form.append("userToken", userToken);
      form.append("askData", "alterWc"+key);
      form.append("value", JSON.stringify(this.currentItem));
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      this.$axios
        .post(this.$url + "/intention", form, config)
        .then((response) => {
          if (response.data.stat === "ok") {
              this.$toast.success("数据更新成功！");
              this.sw.contactor = false;
              this.sw.manufacturer = false;
          } else {
            this.$toast.fail(response.data.info);
          }
        })
        .catch((error) => {
          this.$toast.fail(error + "未知错误！");
        });
    }
  },
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}

.add-b{
    position: absolute;
    right:1.2rem;
    top:1.2rem;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.cell-title {
  overflow: hidden;
  word-break: break-all;
}

.s-w{
    border-bottom: 1px solid #eee;
    padding: 0.8rem;
    height:1.4rem;
}

.s-w span:first-child{
    display: inline-block;
    width:30%;
    text-align: right;
    font-size: 0.7rem;
    color:#666;
}

.s-w select{
    padding: 0.1rem 0.3rem;
    text-align: center;
    border:none;
}

.wc-add-icon{
    position: relative;
    top:0.25rem;
    left:0.2rem;
}

.person-p-w span{
  margin:0 0.2rem;
}

.cor-label{
    text-align: right;
    width:200%;
}

.person-ele{
    border:1px dashed #ccc;
    margin-bottom:0.6rem;
    padding: 0.3rem;
}

.person-p{
    padding: 0.1rem 0;
    text-align: right;
    border-bottom: 1px solid #eee;
}

.person-wrapper input{
    border:none;
}

.s-input{
    border:none;
    text-align: center;
}

.i-wrapper-h{
    padding: 1rem 0;
    text-align: center;
}

.i-wrapper-h input{
    border-bottom:1px solid #ccc;
    padding: 0.2rem;
}

.bottom-wrapper{
  width:100%;
  position: fixed;
  bottom:0;
}
</style>